import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import fr from 'facet-rest';
import { FDBodyText } from '@facet-wealth/design';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

export const metaOverrideSet = fr.metaOverride()
  .overrideAll({
    _hideLabel: true,
  }, { ordinal: 200 })
  .nameOverride(['toModel', 'changedAt'], {
    _component: () => FDBodyText,
    _customProps: {
      color: 'textDisabled',
    },
  }, overrideReadOnly);


export default function ModelChangeEvent() {
  return <>
    <Box display="flex" justifyContent="space-between">
      <MetaControlField attr="toModel" />
      <Box display="flex">
        <MetaControlField attr="changedAt" />
      </Box>
    </Box>
  </>;
}
